import adBuilderTpl from '../templates/ad_builder/ad_builder.html';

export default function strAdBuilder() {
  return {
    restrict: 'EA',
    template: adBuilderTpl,
    controller: 'AdBuilderController',
    controllerAs: 'builderCtrl',
    bindToController: true,
    scope: {
      partner: '='
    }
  };
}
